import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';

const ActiveOverview: FC = ({}) => {
    const { pageStatus } = useMembersStore();
    const { t } = useLang(`membersday.${pageStatus}.ActiveOverview`);
    const [list, setList] = useState([
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006976310/1jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006996211/1jpg.jpg',
            title: t('cardA1'),
            desc: t('cardA2'),
            tips: t('cardA3'),
            show: false,
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007029563/2jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007013267/2jpg.jpg',
            title: t('cardB1'),
            desc: t('cardB2'),
            tips: t('cardB3'),
            show: false,
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007043337/3jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007062892/3jpg.jpg',
            title: t('cardC1'),
            desc: t('cardC2'),
            tips: t('cardC3'),
            show: false,
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007087724/4jpg.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007073724/4jpg.jpg',
            title: t('cardD1'),
            desc: t('cardD2'),
            tips: t('cardD3'),
            show: false,
        },
    ]);

    const handleShow = (e: any, index: number) => {
        // console.log(e);
        e.stopPropagation();
        const arr = [...list];
        arr[index].show = !arr[index].show;
        setList(arr);
    };

    return (
        <div className={styled.content}>
            <div className="members-day-inter">
                {list.map((item: any, index: number) => {
                    return (
                        <div className="box-item" key={index} onClick={(e) => handleShow(e, index)}>
                            <EditorImg pc={item.pc} h5={item.h5} />
                            <div className="box-msgs">
                                <div className="box-title">
                                    <div className="box-title-in">{item.title}</div>
                                    <span className={`box-icon ${item.show && 'active'}`}>
                                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                id="&#239;&#188;&#159;"
                                                d="M1.80312 5.27613C1.51379 3.7268 3.71645 3.3068 3.71645 2.2428C3.71645 1.5988 3.24978 1.13213 2.29779 1.13213C1.66312 1.13213 1.07512 1.41213 0.533785 1.98146L0.0297852 1.5148C0.645785 0.861462 1.37379 0.432129 2.39112 0.432129C3.70712 0.432129 4.54712 1.10413 4.54712 2.17746C4.54712 3.5868 2.31645 3.87613 2.56845 5.27613H1.80312ZM2.20445 7.58146C1.86845 7.58146 1.59778 7.3388 1.59778 6.96546C1.59778 6.59213 1.86845 6.34013 2.20445 6.34013C2.53112 6.34013 2.80179 6.59213 2.80179 6.96546C2.80179 7.3388 2.53112 7.58146 2.20445 7.58146Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </span>
                                    <span className="box-icon-tips">{item.tips}</span>
                                </div>
                                <div className="box-desc">{item.desc}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ActiveOverview;
